import { RabbitVariantIcon } from './RabbitVariantIcon';

/**
 * author: Google
 * id 8CEA8CC8-F495-4F1B-B28B-BAA2D2F2EA44
 * name rabbit-variant
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/rabbit-variant.svg
 * tags
 * - Animal 
 * - Holiday 
 * - Nature 
 */
export const CrueltyFreeIcon = RabbitVariantIcon;
export default CrueltyFreeIcon